module.exports = __webpack_public_path__ + "static/media/img-1.ab6575ad.jpg";